/*
  Phase 3 Block 6 (D-341 to D-343): the replacement parts quick order, snippets/bw-parts-order.liquid.
  One size for the whole order, a tick box per part, a fabric picker inside each ticked part that is made in fabric,
  and one Add to Cart for everything ticked. "Another fabric" swaps Add to Cart for a request through Shopify's
  contact form, moved in under the part it was chosen on (build 3). The cart drawer is opened the way the theme's
  own product form does it (cart:change, variant:add).
  Build 3: the bed page's selected-fabric panel under the swatches on phones and tablets.
  Build 5: on desktop, a fixed preview beside the swatches in place of the floating hover card. It shows the fabric
  under the pointer, and the chosen fabric when the pointer leaves the swatches.
  Phase 3 Block 7 (D-349, boards 73 and 74): a two-fabric swatch (data-pair, on outer covers) previews as two tiles in
  display order, and its order line names both sides (data-order-line). Inner cushion covers show the cushion fabric
  that usually goes with the bed fabric chosen for the outer cover (data-cushion).
*/
(function () {
  if (window.customElements.get('bw-parts-order')) return;

  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    function withDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'number' ? precision : 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  var hoverMq = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)');
  var hoverSwatch = null;
  var hoverTimer = null;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function durabilityHtml(durability) {
    var dots = '';
    for (var i = 1; i <= 5; i += 1) dots += '<span class="bw-dot' + (i <= durability ? ' is-on' : '') + '"></span>';
    return '<p class="bw-fabric-durability"><span>Durability</span> <span class="bw-dots" role="img" aria-label="' + durability + ' out of 5">' + dots + '</span></p>';
  }

  function swatchOf(pick, value) {
    var input = value && value !== '__other' ? Array.from(pick.querySelectorAll('.bwpo-swatch input')).find(function (i) { return i.value === value; }) : null;
    return input ? input.closest('.bwpo-swatch') : null;
  }

  // Block 7: both sides of a two-fabric swatch, one tile each.
  // Build 3: the 640px close-up, so every tile (at most 280px wide) loads at least twice its width.
  function closeUp(image, sizes, cls, size) {
    return '<img class="' + cls + '" src="' + escapeHtml(image) + '" alt="" width="' + size + '" height="' + size + '" loading="lazy">';
  }

  function pairTiles(d, thumbs) {
    return [1, 2].map(function (n) {
      var image = d['s' + n + 'Image'];
      var name = d['s' + n + 'Name'] || '';
      var url = d['s' + n + 'Url'];
      return '<div class="bwpo-pair__side">' +
        (image ? closeUp(image, thumbs ? '(max-width: 699px) calc(50vw - 48px), 220px' : '134px', 'bwpo-pair__image', 140) : '<span class="bwpo-pair__image is-empty"></span>') +
        '<p class="bwpo-pair__role">' + escapeHtml(d['s' + n + 'Role']) + '</p>' +
        '<p class="bwpo-pair__name">' + escapeHtml(name) + '</p>' +
        (d['s' + n + 'Type'] ? '<p class="bwpo-pair__type">' + escapeHtml(d['s' + n + 'Type']) + '</p>' : '') +
        (thumbs && url ? '<a class="bw-fabric-panel__link link" href="' + escapeHtml(url) + '">About ' + escapeHtml(name) + '</a>' : '') +
        '</div>';
    }).join('');
  }

  // The desktop preview beside the swatches: the swatch under the pointer, else the chosen fabric, else a prompt.
  function renderPreview(pick) {
    var preview = pick && pick.querySelector('[data-fabric-preview]');
    if (!preview) return;
    var checked = pick.querySelector('input[type="radio"]:checked');
    var value = checked ? checked.value : '';
    var swatch = hoverSwatch && pick.contains(hoverSwatch) ? hoverSwatch : swatchOf(pick, value);
    var chosen = !!swatch && !!checked && swatch.contains(checked);
    var key = swatch ? swatch.dataset.fabricName + (chosen ? '|chosen' : '|hover') : (value === '__other' ? '|other' : '|empty');
    if (preview.dataset.key === key) return;
    preview.dataset.key = key;
    // Build 2: nothing before a hover or a choice; the column keeps its width, so the swatches do not move.
    if (!swatch) {
      preview.innerHTML = value === '__other'
        ? '<p class="bwpo-preview__note">Another fabric, by request. Tell us what you have in mind in the form below.</p>'
        : '';
      return;
    }
    var d = swatch.dataset;
    if ('pair' in d) {
      preview.innerHTML =
        '<p class="bwpo-preview__state">' + (chosen ? 'Your choice' : 'Pointing at') + ': ' + escapeHtml(d.display || d.fabricName) + '</p>' +
        '<div class="bwpo-pair">' + pairTiles(d, false) + '</div>' +
        (swatch.classList.contains('is-out') ? '<p class="bwpo-preview__out">Sold out in this style.</p>' : '') +
        '<p class="bwpo-preview__desc">The cover is made in both fabrics, as on your bed.</p>';
      return;
    }
    var finish = [d.fabricFinish ? d.fabricFinish + ' finish.' : '', d.fabricCare || ''].filter(Boolean).join(' ');
    var durability = parseInt(d.fabricDurability, 10) || 0;
    preview.innerHTML =
      '<div class="bwpo-preview__art">' + (d.fabricImage ? '<img src="' + escapeHtml(d.fabricImage) + '" alt="" width="280" height="280">' : '') + '</div>' +
      '<div class="bwpo-preview__body">' +
      '<p class="bwpo-preview__state">' + (chosen ? 'Your choice' : '&nbsp;') + '</p>' +
      '<p class="bwpo-preview__title"><span class="bwpo-preview__name">' + escapeHtml(d.fabricName) + '</span>' + (d.fabricType ? '<span class="bwpo-preview__type">' + escapeHtml(d.fabricType) + '</span>' : '') + '</p>' +
      (d.paired ? '<p class="bwpo-paired">Usually paired with ' + escapeHtml(d.paired) + '.</p>' : '') +
      (swatch.classList.contains('is-out') ? '<p class="bwpo-preview__out">Sold out in this style.</p>' : '') +
      (finish ? '<p>' + escapeHtml(finish) + '</p>' : '') +
      (durability > 0 ? durabilityHtml(durability) : '') +
      (d.fabricDescription ? '<p class="bwpo-preview__desc">' + escapeHtml(d.fabricDescription) + '</p>' : '') +
      (chosen && d.fabricUrl ? '<a class="bwpo-preview__link link" href="' + escapeHtml(d.fabricUrl) + '">About ' + escapeHtml(d.fabricName) + '</a>' : '') +
      '</div>';
  }

  document.addEventListener('pointerover', function (event) {
    if (!hoverMq.matches || (event.pointerType && event.pointerType !== 'mouse')) return;
    var swatch = event.target.closest && event.target.closest('bw-parts-order .bwpo-swatch');
    if (!swatch) return;
    clearTimeout(hoverTimer);
    if (hoverSwatch === swatch) return;
    var before = hoverSwatch;
    hoverSwatch = swatch;
    if (before && !swatch.closest('[data-picker]').contains(before)) renderPreview(before.closest('[data-picker]'));
    renderPreview(swatch.closest('[data-picker]'));
  });
  document.addEventListener('pointerout', function (event) {
    if (!hoverSwatch) return;
    var swatch = event.target.closest && event.target.closest('bw-parts-order .bwpo-swatch');
    if (!swatch || (event.relatedTarget && swatch.contains(event.relatedTarget))) return;
    clearTimeout(hoverTimer);
    // A short wait, so crossing the gap between two swatches does not flash back to the chosen fabric.
    hoverTimer = setTimeout(function () {
      var pick = hoverSwatch && hoverSwatch.closest('[data-picker]');
      hoverSwatch = null;
      renderPreview(pick);
    }, 120);
  });

  class BwPartsOrder extends HTMLElement {
    connectedCallback() {
      this.retired = this.dataset.retired === 'true';
      this.moneyFormat = this.dataset.moneyFormat;
      this.rows = Array.from(this.querySelectorAll('[data-row]')).map((el) => {
        var data = {};
        try { data = JSON.parse(el.querySelector('[data-variants]').textContent); } catch (e) { data = {}; }
        return {
          el: el,
          fabric: el.dataset.fabric === 'true',
          name: el.dataset.name,
          variants: data,
          tick: el.querySelector('[data-tick]'),
          qty: el.querySelector('[data-qty]'),
          price: el.querySelector('[data-price]'),
          tag: el.querySelector('[data-tag]'),
          picker: el.querySelector('[data-picker]'),
          label: el.querySelector('[data-fabric-label]'),
          guide: el.querySelector('[data-cushion-guide]'),
          typed: el.querySelector('[data-typed]'),
          typedInput: el.querySelector('[data-typed-input]')
        };
      });
      this.atc = this.querySelector('[data-atc]');
      this.count = this.querySelector('[data-count]');
      this.sub = this.querySelector('[data-sub]');
      this.error = this.querySelector('[data-error]');
      this.order = this.querySelector('[data-order]');
      this.req = this.querySelector('[data-req]');
      this.reqForm = this.querySelector('.bwpo-req-form');
      // The request form's home, under the parts list; it moves in under the part where Another fabric is chosen.
      if (this.reqForm) {
        this.reqHome = document.createComment('bwpo-request-home');
        this.reqForm.parentNode.insertBefore(this.reqHome, this.reqForm);
      }
      // A request that came back with errors stays open where it is until the customer changes something.
      this.keepReq = !!(this.req && this.req.hasAttribute('data-req-errors'));

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-typed-input], [data-qty]')) this.update();
      });
      this.addEventListener('click', this.onClick.bind(this));
      if (this.atc) this.atc.addEventListener('click', this.addToCart.bind(this));

      this.update();
      var done = this.querySelector('.bwpo-req--done');
      if (done) done.scrollIntoView({ block: 'center' });
      else if (this.req && !this.req.hidden) this.req.scrollIntoView({ block: 'center' });
    }

    size() {
      var checked = this.querySelector('.bwpo-sizes input:checked');
      return checked ? checked.value : '';
    }

    fabricOf(row) {
      if (!row.picker) return '';
      var checked = row.picker.querySelector('input:checked');
      return checked ? checked.value : '';
    }

    // Block 7: the chosen swatch's label element, for its data- fields.
    chosenSwatch(row) {
      if (!row.picker) return null;
      var checked = row.picker.querySelector('.bwpo-swatch input:checked');
      return checked ? checked.closest('.bwpo-swatch') : null;
    }

    onClick(event) {
      var minus = event.target.closest('[data-qty-minus]');
      var plus = event.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var row = this.rows.find((r) => r.el.contains(event.target));
      if (!row) return;
      var value = parseInt(row.qty.value, 10) || 1;
      value = minus ? Math.max(1, value - 1) : Math.min(99, value + 1);
      row.qty.value = value;
      if (!row.tick.checked) row.tick.checked = true;
      this.onTick(row);
      this.update();
    }

    onChange(event) {
      this.keepReq = false;
      var row = this.rows.find((r) => r.el.contains(event.target));
      if (row && event.target === row.tick) this.onTick(row);
      this.error.hidden = true;
      this.update();
    }

    onTick(row) {
      if (!row.tick.checked || !row.fabric || !row.picker || this.fabricOf(row)) return;
      // A second fabric part starts on the fabric already chosen for another part, when it is offered here.
      var other = this.rows.find((r) => r !== row && r.tick.checked && this.fabricOf(r) && this.fabricOf(r) !== '__other');
      if (!other) return;
      var value = this.fabricOf(other);
      // Block 7: from a two-fabric outer cover, a cushion cover starts on the bed's cushion fabric (build 2: always
      // on its list now), never on the outer cover's own value.
      var source = this.chosenSwatch(other);
      if (source && 'pair' in source.dataset && row.guide) value = source.dataset.cushion || '';
      if (!value) return;
      var input = Array.from(row.picker.querySelectorAll('input')).find((i) => i.value === value && !i.disabled);
      if (input) input.checked = true;
    }

    update() {
      var size = this.size();
      var count = 0;
      var cents = 0;
      var missing = false;
      var anyOther = false;
      var names = [];

      // Block 7: the bed fabric, from a ticked outer cover whose two-fabric swatch is chosen.
      var bed = null;
      this.rows.forEach((row) => {
        var sw = row.tick.checked ? this.chosenSwatch(row) : null;
        if (!bed && sw && 'pair' in sw.dataset && sw.dataset.cushion) bed = sw.dataset;
      });
      this.rows.forEach((row) => {
        if (!row.guide) return;
        row.guide.hidden = !bed;
        row.guide.textContent = bed ? 'On a ' + bed.fabricName + ' bed, the cushion is usually ' + bed.cushion + '.' : '';
      });

      var otherRow = null;
      this.rows.forEach((row) => {
        var on = row.tick.checked;
        var variant = size ? row.variants[size] : null;
        var buyable = !!(variant && variant.available);

        row.el.classList.toggle('is-on', on);
        row.el.classList.toggle('is-unavailable', !!size && !buyable);
        if (!size) row.price.textContent = row.price.dataset.from;
        else if (!variant) row.price.textContent = 'Not made in ' + size;
        else if (!variant.available) row.price.textContent = 'Sold out';
        else row.price.textContent = variant.price;

        var fabric = this.fabricOf(row);
        if (row.picker) {
          row.picker.hidden = !on;
          // Build 4: a two-fabric choice reads its display name, "Sanibel Stripe & Linen".
          var shown = this.chosenSwatch(row);
          var display = shown && shown.dataset.display ? shown.dataset.display : fabric;
          if (row.label) row.label.textContent = fabric === '__other' ? 'Another fabric' : (display || 'choose one');
          this.updatePanel(row, fabric);
        }
        if (on && fabric === '__other' && !otherRow) otherRow = row;
        if (row.typed) row.typed.hidden = !on;

        if (row.fabric && row.tag) {
          if (this.retired) row.tag.textContent = "Made in your bed's fabric";
          else if (!on) row.tag.textContent = 'Made in your choice of fabric';
          else if (fabric === '__other') row.tag.textContent = 'Another fabric, by request';
          else if (fabric) row.tag.textContent = 'In ' + ((row.picker && this.chosenSwatch(row) && this.chosenSwatch(row).dataset.display) || fabric);
          else row.tag.textContent = 'Choose a fabric below';
        }

        if (!on) return;
        if (size && !buyable) return;
        var qty = Math.max(1, parseInt(row.qty.value, 10) || 1);
        count += qty;
        if (variant) cents += variant.cents * qty;
        names.push((qty > 1 ? qty + ' x ' : '') + row.name);
        if (row.fabric) {
          if (this.retired) {
            if (!row.typedInput || !row.typedInput.value.trim()) missing = true;
          } else if (fabric === '__other') {
            anyOther = true;
          } else if (!fabric) {
            missing = true;
          }
        }
      });

      var label = 'Add to Cart';
      var ok = true;
      if (!size) { label = 'Choose Your Size'; ok = false; }
      else if (count === 0) { label = 'Choose Your Parts'; ok = false; }
      else if (missing) { label = this.retired ? "Enter Your Bed's Fabric" : 'Choose a Fabric'; ok = false; }
      this.atc.textContent = label;
      this.atc.disabled = !ok;

      this.count.textContent = count === 0 ? 'No parts chosen' : count + (count === 1 ? ' part' : ' parts') + (size ? ', ' + formatMoney(cents, this.moneyFormat) : '');
      this.sub.textContent = !size ? 'Choose your size and the parts you need.' : (count === 0 ? 'Tick the parts you need above.' : 'Size ' + size);

      if (this.req) {
        var showReq = anyOther || this.keepReq;
        this.order.hidden = showReq;
        this.req.hidden = !showReq;
        if (otherRow && this.reqForm.parentNode !== otherRow.el) {
          otherRow.el.appendChild(this.reqForm);
        } else if (!otherRow && this.reqHome && this.reqForm.previousSibling !== this.reqHome) {
          this.reqHome.parentNode.insertBefore(this.reqForm, this.reqHome.nextSibling);
        }
        var reqSize = this.req.querySelector('[data-req-size]');
        var reqParts = this.req.querySelector('[data-req-parts]');
        var summary = this.req.querySelector('[data-req-summary]');
        if (reqSize) reqSize.value = size;
        if (reqParts) reqParts.value = names.join(', ');
        if (summary) summary.textContent = 'Size: ' + (size || 'not chosen yet') + '. Parts: ' + (names.length ? names.join(', ') : 'none ticked yet') + '.';
      }
    }

    updatePanel(row, fabric) {
      renderPreview(row.picker);
      var panel = row.picker.querySelector('[data-fabric-panel]');
      if (!panel) return;
      var input = fabric && fabric !== '__other' ? Array.from(row.picker.querySelectorAll('input')).find((i) => i.value === fabric) : null;
      var swatch = input ? input.closest('.bwpo-swatch') : null;
      if (!swatch) { panel.hidden = true; panel.innerHTML = ''; return; }
      if (panel.dataset.fabric === fabric) { panel.hidden = false; return; }
      var d = swatch.dataset;
      if ('pair' in d) {
        panel.innerHTML = '<div class="bwpo-pair">' + pairTiles(d, true) + '</div>';
        panel.classList.add('bw-fabric-panel--pair');
        panel.dataset.fabric = fabric;
        panel.hidden = false;
        return;
      }
      panel.classList.remove('bw-fabric-panel--pair');
      var finish = [d.fabricFinish ? d.fabricFinish + ' finish.' : '', d.fabricCare || ''].filter(Boolean).join(' ');
      var durability = parseInt(d.fabricDurability, 10) || 0;
      panel.innerHTML =
        (d.fabricImage ? closeUp(d.fabricImage, '112px', 'bw-fabric-panel__image', 112) : (d.fabricThumb ? '<img class="bw-fabric-panel__image" src="' + escapeHtml(d.fabricThumb) + '" width="112" height="112" alt="" loading="lazy">' : '')) +
        '<div class="bw-fabric-panel__body">' +
        '<p class="bw-fabric-panel__title"><span class="bw-fabric-panel__name">' + escapeHtml(d.fabricName) + '</span>' + (d.fabricType ? ' <span class="bw-fabric-panel__type">' + escapeHtml(d.fabricType) + '</span>' : '') + '</p>' +
        (d.paired ? '<p class="bwpo-paired">Usually paired with ' + escapeHtml(d.paired) + '.</p>' : '') +
        (finish ? '<p>' + escapeHtml(finish) + '</p>' : '') +
        (durability > 0 ? durabilityHtml(durability) : '') +
        (d.fabricUrl ? '<a class="bw-fabric-panel__link link" href="' + escapeHtml(d.fabricUrl) + '">About ' + escapeHtml(d.fabricName) + '</a>' : '') +
        '</div>';
      panel.dataset.fabric = fabric;
      panel.hidden = false;
    }

    async addToCart() {
      var size = this.size();
      var items = [];
      this.rows.forEach((row) => {
        if (!row.tick.checked) return;
        var variant = row.variants[size];
        if (!variant || !variant.available) return;
        var item = { id: variant.id, quantity: Math.max(1, parseInt(row.qty.value, 10) || 1) };
        if (row.fabric) {
          var fabric = this.retired ? (row.typedInput ? row.typedInput.value.trim() : '') : this.fabricOf(row);
          // Block 7: a two-fabric cover names both sides on the order line.
          var chosen = this.retired ? null : this.chosenSwatch(row);
          if (chosen && 'pair' in chosen.dataset && chosen.dataset.orderLine) fabric = chosen.dataset.orderLine;
          if (fabric && fabric !== '__other') item.properties = { Fabric: fabric };
        }
        items.push(item);
      });
      if (!items.length) return;

      this.atc.setAttribute('aria-busy', 'true');
      this.atc.disabled = true;
      this.error.hidden = true;
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));

      try {
        var response = await fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname })
        });
        var json = await response.json();
        if (!response.ok) {
          this.error.textContent = json.description || json.message || 'These parts could not be added. Please try again.';
          this.error.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') {
          window.location.href = Shopify.routes.root + 'cart';
          return;
        }
        var cart = await (await fetch(Shopify.routes.root + 'cart.js')).json();
        cart.sections = json.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart }
        }));
      } catch (e) {
        this.error.textContent = 'These parts could not be added. Please try again.';
        this.error.hidden = false;
      } finally {
        this.atc.removeAttribute('aria-busy');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        this.update();
      }
    }
  }

  window.customElements.define('bw-parts-order', BwPartsOrder);
})();
